import { render } from "./EmbassiesList.vue?vue&type=template&id=6779bce5&scoped=true"
import script from "./EmbassiesList.vue?vue&type=script&lang=js"
export * from "./EmbassiesList.vue?vue&type=script&lang=js"

import "./EmbassiesList.vue?vue&type=style&index=0&id=6779bce5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6779bce5"]])

export default __exports__